import {Component, OnInit} from '@angular/core';
import {AppSettingsService} from '../app-settings.service';
import {User, UserService} from '../user.service';
import {Observable} from 'rxjs/Observable';
import 'rxjs/operator/map';
import {isNullOrUndefined} from "util";

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css']
})
export class SideMenuComponent implements OnInit {

  isMenuCollapsed: boolean;

  menuState: boolean[] = new Array<boolean>();

  showManagement: Observable<boolean>;

  togleSubMenuState(subMenu: string) {
    const menuStateValue = this.menuState[subMenu];
    if (menuStateValue) {
      this.menuState[subMenu] = !this.menuState[subMenu];
    } else {
      this.menuState[subMenu] = true;
    }
  }

  getSubMenuState(subMenu: string): boolean {
    const menuStateValue = this.menuState[subMenu];
    if (menuStateValue) {
      return menuStateValue;
    } else {
      return false;
    }
  }

  constructor(private ass: AppSettingsService, public us: UserService) {
    this.showManagement = us.currentUser
      .map((user: User) => {
        console.log(`show management: ${(!isNullOrUndefined(user) && user.hasAnyRole(['USER_ADMIN', 'ROOT']))}`);
        return (!isNullOrUndefined(user) && user.hasAnyRole(['USER_ADMIN', 'ROOT']));
      });
  }

  ngOnInit() {
    this.ass.menuState.subscribe((state: boolean) => {
      this.isMenuCollapsed = !state;
    });
  }

}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/side-menu/side-menu.component.ts